import { z } from 'zod';
/** Public tenant job id (container slot scan + wafer transfer). Format: job-{ms}-{suffix} */
export const publicTenantJobIdSchema = z
    .string()
    .regex(/^job-\d+-[a-z0-9]+$/, 'Invalid jobId format');
/** Route param for any tenant EFEM job id. */
export const tenantJobIdParamSchema = z.object({
    jobId: publicTenantJobIdSchema,
});
export const waferTransferJobIdParamSchema = tenantJobIdParamSchema;
//# sourceMappingURL=tenant-job-id.schemas.js.map